/**
 * OrdinalId
 *
 * Id for an Ordinal. A higher OrdinalId is above a lower OrdinalId,
 * but the range of OrdinalIds at a Venue is not necessarily
 * contiguous or all positive.
 * OrdinalIds typically *don't* match the ClFloorId for a level.
 *
 *
 *
 * @module DataTypes.Ordinal
 */
import * as R from 'ramda';
import { createSchemaBasedConstructor } from './create-typed-constructor';

const Ordinal = createSchemaBasedConstructor('Ordinal');

// Static members of the Ordinal 'class'
Ordinal.LANDSCAPE_BACKGROUND = 'landscape-background';

/*
 * Take a list of ordinals for a venue and return the default one
 * @sig getDefaultOrdinalForVenue :: [Ordinal] -> Ordinal
 */
Ordinal.getDefaultOrdinalForVenue = ordinals => {
    const findDefaultOrdinal = o => o.isDefaultForVenue;

    return R.find(findDefaultOrdinal, ordinals);
};

export default Ordinal;
